<template>
  <div class="navbar-container">
    <div class="navbar">
      <!-- logo -->
      <div class="logo" @click="handleClick_logo">
        <img src="/static/imgs/logo.png" alt="logo" />
      </div>
      <!-- 导航按钮（仅移动端显示） -->
      <div v-if="isMobile" class="navbar-toggle">
        <span class="" @click="toggleLanguage">EN | CN</span>
        <div @click="toggleMenu">
          <i v-if="isMenuOpen" class="el-icon-close icon"></i>
          <i v-else class="el-icon-menu icon"></i>
        </div>
      </div>
      <!-- 移动端导航 -->
      <div
        v-if="isMobile && isMenuOpen"
        class="mobileNav-container"
      >
        <el-collapse class="mobileNav-primary">
          <el-collapse-item
            class="mobileNav-item"
            v-for="(item, index) in nav_list"
            :key="index"
            :title="item.name">
            <template slot="title">
              <div @click="handleMenuClick(item)">{{ item.name }}</div>
            </template>
            <ul
              v-if="item.children && item.children.length > 0"
              class="mobileNav-secondary">
              <li
                class="mobileNav-sub-item"
                v-for="subItem in item.children"
                :key="subItem.name">
                <div @click="handleMenuClick(item, subItem)">{{ subItem.name }}</div>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!-- pc端导航 -->
      <div v-if="!isMobile" class="nav-container">
        <div class="nav-search">
          <div class="search-input">
            <el-input v-model="search_input" size="small"></el-input>
            <img src="/static/imgs/search.png" alt="search" />
          </div>
        </div>
        <ul class="nav-primary">
          <li
            class="nav-item"
            v-for="(item, index) in nav_list"
            :key="index"
            @mouseenter="showSubNav(item, index)"
            @mouseleave="scheduleHideSubNav(item, index)">
            <div class="nav-item-link" @click="handleMenuClick(item)">
              <span>{{ item.name }}</span>
              <span v-if="item.children && item.children.length > 0" class="arrow">▼</span>
            </div>
            <ul
              v-if="item.children && item.children.length > 0"
              class="nav-secondary"
              :ref="'subNav' + index"
              :class="{ active: activeNav === index }"
              @mouseenter="cancelHideSubNav()"
              @mouseleave="scheduleHideSubNav(index)"
              :style="{
                height: activeNav === index ? subNavHeights[index] + 'px' : '0px',
                opacity: activeNav === index ? 1 : 0,
              }"
            >
              <li
                class="nav-sub-item"
                v-for="subItem in item.children"
                :key="subItem.name">
                <div class="nav-sub-item-link" @click="handleMenuClick(item, subItem)">{{ subItem.name }}</div>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <div class="nav-item-link" @click="toggleLanguage">
              <img class="language" src="/static/imgs/language.png" alt="language" />
              <span>CN/EN</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMenuOpen: false, // 移动端-导航是否打开
      activeNav: null, // pc端-当前激活的一级导航索引
      hideTimeout: null, // pc端-隐藏二级导航定时器
      subNavHeights: {}, // pc端-记录每个二级菜单的高度
      search_input: "", // pc端-搜索框输入内容
    };
  },
  computed: {
    // 导航列表
    nav_list() {
      return this.$store.state.nav.content.nav_list;
    },
    // 从vuex获取设备类型
    isMobile() {
      return this.$store.getters['common/isMobile'];
    },
  },
  methods: {
    // 语言切换
    toggleLanguage() {
      // 获取当前语言
      const currentLang = this.$i18n.locale;
      // 判断当前语言并切换到另一种语言
      const nextLang = currentLang === 'en' ? 'zh' : 'en';
      this.$i18n.locale = nextLang; // 切换语言
      this.$store.dispatch('loadAllModulesContent'); // 重新加载所有模块的内容
    },
    // 导航点击事件
    handleMenuClick(item, subItem) {
      this.isMenuOpen = false;
      if (subItem) {
        if (subItem.path) {
          this.navigate(subItem.path);  // 处理路径跳转
        } else {
          if (this.$route.hash == `#${subItem.anchor}`) {
            this.scrollTo(subItem.anchor)
          } else {
            this.$router.push(`${item.link}#${subItem.anchor}`);
          }
        }
      } else {
        // 处理点击菜单项
        this.navigate(item.link);
      }
    },
    // 用于处理路由跳转的逻辑
    navigate(path) {
      if (this.$route.path === path) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        this.$router.push(path);
      }
    },
    // 滚动到指定锚点
    scrollTo(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    // 移动端-导航按钮点击事件
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    // pc端-显示二级导航
    showSubNav(item, index) {
      if (!item.children || !item.children.length) {
        return;
      }
      // 激活当前菜单
      this.activeNav = index;
      this.$nextTick(() => {
        const subNav = this.$refs[`subNav${index}`][0]; // 获取对应的二级菜单 DOM
        if (subNav) {
          this.$set(this.subNavHeights, index, subNav.scrollHeight); // 保存二级菜单高度
        }
      });
      // 清除任何隐藏定时器
      this.cancelHideSubNav();
    },
    // pc端-隐藏二级导航
    scheduleHideSubNav(item, index) {
      // 延迟隐藏
      this.hideTimeout = setTimeout(() => {
        if (this.activeNav === index) {
          this.activeNav = null;
        }
      }, 200); // 延迟 200ms
    },
    // pc端-清除隐藏的定时器
    cancelHideSubNav() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
    },
    // logo点击事件
    handleClick_logo() {
      this.isMenuOpen = false;
      this.activeNav = null;
      this.subNavHeights = {};
      this.navigate("/");
    },
  },
};
</script>

<style lang="scss">
/* pc端-搜索框样式覆盖 */
.search-input {
  width: 270px;
  position: relative;
  .el-input__inner {
    padding-right: 40px;
    border-radius: 38px;
    border: 1px solid #0C3C5A;
    color: #000;
  }
  .el-input__suffix {
    color: #0C3C5A;
  }
  img {
    position: absolute;
    right: 10px;
    top: 4px;
    width: 24px;
    height: 24px;
    z-index: 999;
  }
}


/* 移动端-导航折叠面板样式覆盖 */
.mobileNav-primary {
  .el-collapse-item__header {
    padding: 0 20px;
  }
  .el-collapse-item__content {
    padding: 0 20px 0 40px;
  }
}
</style>
<style lang="scss" scoped>
/* 导航栏容器 */
.navbar-container {
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  z-index: 99;
}
/* 导航栏内容 */
.navbar {
  width: var(--max);
  margin: auto;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* logo */
.logo {
  height: 80px;
  overflow: hidden;
  cursor: pointer;
  img {
    width: auto;
    height: 100%;
  }
}
/* 移动端-导航按钮 */
.navbar-toggle {
  font-size: 30px;
  display: flex;
  align-items: center;
  span {
    font-size: var(--font24);
    margin-right: 20px;
    color: #acafb2;
    cursor: pointer;
  }
  i {
    cursor: pointer;
  }
}
/* 移动端-导航 */
.mobileNav-container {
  position: fixed;
  top: 70px;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: calc(100vh - 70px);
  background-color: #ffffff;
  .mobileNav-sub-item {
    margin: 20px 0;
  }
}
/* pc端-导航容器 */
.nav-container {
  width: calc(100% - 200px);
}
/* pc端-搜索框 */
.nav-container .nav-search {
  display: flex;
  justify-content: end;
}
/* pc端-导航 */
.nav-container .nav-primary {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-top: 10px;
  .nav-item {
    position: relative;
    .nav-item-link {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      padding: 10px 20px;
      font-size: var(--font16);
      cursor: pointer;
    }
    .nav-item-link span {
      white-space: nowrap;
    }
    .nav-item-link .language {
      width: 24px;
      height: 24px;
      margin-right: 5px;
      color: #000;
    }
    .nav-item-link .arrow {
      margin-left: 5px;
      color: #0C3C5A;
    }
  }
  .nav-secondary {
    position: absolute;
    top: calc(100% + 20px);
    left: 0;
    background-color: rgba(255, 255, 255, 0.6);
    white-space: nowrap;
    min-width: 150px;
    z-index: 999;

    /* 初始隐藏状态 */
    height: 0;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;

    /* 动画效果 */
    transition: height 0.3s ease, opacity 0.3s ease;

    &.active {
      /* 显示状态 */
      visibility: visible; /* 防止闪烁 */
    }
  }
  .nav-sub-item-link {
    display: block;
    padding: 20px;
    font-size: var(--font14);
    cursor: pointer;
    &:hover {
      background-color: #f0f0f0;
    }
  }
}


@media screen and (max-width: 1200px) {
  .logo {
    height: 60px;
  }
}
@media screen and (max-width: 900px) {
  /* pc端-导航容器 */
  .nav-container {
    width: calc(100% - 120px);
  }
}
@media screen and (max-width: 768px) {
  .navbar-container {
    height: 70px;
    background: #ffffff;
    position: fixed;
    top: 0;
  }
  .navbar {
    margin: 0 auto;
  }
  .logo {
    height: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue